(function () {
  function initCarousel(root) {
    if (!root || root.dataset.mhReady) return;
    root.dataset.mhReady = '1';
    var slides = root.querySelectorAll('.mh-car-slide');
    var dots = root.querySelectorAll('.mh-car-dot');
    var rows = root.querySelectorAll('.mh-values-row');
    var pauseBtn = root.querySelector('.mh-car-pause');
    var secs = parseInt(root.dataset.seconds || '7', 10);
    var autoplay = root.dataset.autoplay === 'true';
    var i = 0, timer = null, paused = !autoplay;
    root.style.setProperty('--mh-car-secs', secs + 's');
    if (slides.length < 2) return;

    function lazy(slide) {
      slide.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src');
      });
    }
    function restartBar() {
      dots.forEach(function (d) {
        var s = d.querySelector('span');
        if (!s) return;
        s.style.animation = 'none'; void s.offsetWidth; s.style.animation = '';
      });
    }
    function go(n) {
      slides[i].classList.remove('mh-is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      if (dots[i]) dots[i].classList.remove('mh-is-active');
      i = (n + slides.length) % slides.length;
      lazy(slides[i]);
      slides[i].classList.add('mh-is-active');
      slides[i].setAttribute('aria-hidden', 'false');
      if (dots[i]) dots[i].classList.add('mh-is-active');
      rows.forEach(function (r, k) {
        var on = k === i;
        r.classList.toggle('mh-is-active', on);
        r.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      restartBar();
    }
    function start() {
      clearInterval(timer);
      if (paused) return;
      timer = setInterval(function () { go(i + 1); }, secs * 1000);
    }
    root.querySelectorAll('.mh-car-arrow').forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.dataset.dir, 10)); start(); });
    });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); start(); });
    });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        root.classList.toggle('mh-is-paused', paused);
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        if (!paused) restartBar();
        start();
      });
    }
    root.classList.toggle('mh-is-paused', paused);
    // Keyboard: left/right arrow keys change slides while the hero is on screen
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      var t = e.target, tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
      if (document.querySelector('[role="dialog"][aria-modal="true"]:not([hidden])')) return;
      var r = root.getBoundingClientRect();
      if (r.bottom < 80 || r.top > window.innerHeight - 80) return;
      e.preventDefault();
      go(i + (e.key === 'ArrowRight' ? 1 : -1));
      start();
    });
    // Theme editor: selecting a slide block shows that slide
    document.addEventListener('shopify:block:select', function (e) {
      var k = Array.prototype.indexOf.call(slides, e.target.closest ? e.target.closest('.mh-car-slide') : null);
      if (k > -1) { go(k); paused = true; clearInterval(timer); root.classList.add('mh-is-paused'); }
    });
    // load slide 2+ images after the first slide is shown
    window.addEventListener('load', function () { slides.forEach(lazy); });
    start();
  }

  function initLids(root) {
    if (!root || root.dataset.mhReady) return;
    root.dataset.mhReady = '1';
    var main = root.querySelector('.mh-lid-main');
    var link = root.querySelector('.mh-lid-stage');
    var name = root.querySelector('.mh-sw-name');
    root.querySelectorAll('.mh-sw').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('.mh-sw').forEach(function (x) { x.classList.remove('mh-is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('mh-is-on'); b.setAttribute('aria-pressed', 'true');
        main.style.opacity = 0;
        setTimeout(function () {
          main.src = b.dataset.src; main.removeAttribute('srcset');
          main.alt = b.dataset.name + ' straw lid';
          main.style.opacity = 1;
        }, 180);
        if (name) name.textContent = b.dataset.name;
        if (link && b.dataset.url) link.href = b.dataset.url;
      });
    });
  }

  // Quick add fallback when the theme's ajax cart is not handling the click
  function initQuickAdd() {
    if (window.mhQuickAddReady) return;
    window.mhQuickAddReady = true;
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.mh-qa-form');
      if (!form) return;
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart && window.PXUTheme.jsAjaxCart.addToCart) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = btn.querySelector('.text');
      var old = label ? label.textContent : '';
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (label) label.textContent = form.dataset.added || 'Added';
          document.querySelectorAll('[data-cart-count], .cart_count, .cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          setTimeout(function () { if (label) label.textContent = old; btn.disabled = false; }, 2200);
        })
        .catch(function () { form.submit(); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.mh-hero-car').forEach(initCarousel);
    (scope || document).querySelectorAll('.mh-lids-root').forEach(initLids);
    initQuickAdd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
